import { Injectable } from "@angular/core";
import { HttpProvider } from "../http/http";
import { APP_CONFIG } from "../../environment";
import { RouteProvider } from "../../providers/route/route";
import { TranslateService } from "@ngx-translate/core";
import { PinActionType } from '../../model/types/wallet-pin-action-type';
import { CARDACTIONTYPE, CARDSTATUS, CARDTYPE, WALLETCARDACTIONTYPE , WALLETCARDRETVAL, WALLETCARDTYPE, WALLETCARDPINTYPE, WalletCardsStatuses, WALLETSTATUSSTRING } from '../../model/models/wallet/wallet-card';
import { WalletCard } from "../../model/models/wallet/wallet";
import { CallProvider } from "../../providers/call/call";
import { AnalyticsCardLostReasonsType, AnalyticsEventType, AnalyticsWalletCard, ContactModalReasons, SegmentLocationNames } from "../../model/types/analytics.const";
import { SegmentProvider } from "../../providers/analytics/segment";
import { RSAEncryptnProvider } from "../../providers/rsa-encrypt/rsa-encrypt";
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { RmtTranslateComponent } from "../../components/rmt-translate/rmt-translate";
import { Contact } from "@ionic-native/contacts";
@Injectable()
export class WalletCardProvider {

    walletCardPinMaxlength: number = 6;
    walletCvvdMaxlength: number = 3;
    walletCards: any;
    constructor(
        private httpProvider: HttpProvider,
        private routeProvider: RouteProvider,
        private translate: TranslateService,
        private call: CallProvider,
        private analytics: SegmentProvider,
        private rsaEncryptnProvider: RSAEncryptnProvider,
        private utilsProvider: UtilsProvider,
        
    ) {
    }

    // API/WS http calls 
    async applyWalletCard(payload) {
        const result = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/wallet/cards/register`, payload);
        return result
    }

    async replacementWalletCard(payload) {
        const result = await this.httpProvider.put(`${APP_CONFIG.API_URL}api/wallet/cards/replacement`, payload);
        return result
    }

    async activePhysicalCard(payload) {
        const result = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/wallet/cards/activate`, payload);
        return result
    }

    async setPhysicalPinCard(payload) {
        const result = await this.httpProvider.put(`${APP_CONFIG.API_URL}api/wallet/cards/resetpin`, payload);
        return result
    }

    async lockOrUnlockOrBlockCard(proxyNumber: string, status: number, transactionPin: string = "", notes: string = ""): Promise<any> {
        return this.httpProvider.put(APP_CONFIG.API_URL + 'api/wallet/cards', { ProxyNumber: proxyNumber, Status: status, Notes: notes, TransactionPin: transactionPin });
    }

    async getCardChannelsByType(proxyNumber: string, controlType: number): Promise<any[]> {
        return this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/cards/channels?proxynumber=${proxyNumber}&controltype=${controlType}`);
    }

    async updateCardChannles(postBody): Promise<any> {
        return this.httpProvider.put(APP_CONFIG.API_URL + 'api/wallet/cards/channels', postBody);
    }

    async getCardLimitsAndFees(proxyNumber: string): Promise<any[]> {
        return this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/cards/limits?proxynumber=${proxyNumber}`);
    }

    async getCardDetails(proxyNumber: string): Promise<any[]> {
        let result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/cards/securitytoken?proxyNumber=${proxyNumber}`);
        let infoToGetDetails = result.Value;
        if(result && result.Result && result.Result.RetVal === WALLETCARDRETVAL.SUCCESS && infoToGetDetails && infoToGetDetails.DecryptionKey !== ""
            && infoToGetDetails.EnToken !== "" && infoToGetDetails.ProxyNumber !== "" && infoToGetDetails.RiaToken !== "" && infoToGetDetails.Url !== ""){
                let parsedDate = this.utilsProvider.getDateInNumbers();
                let requestData = "{'function':'FETCHCVV2','proxyNumber':'"+infoToGetDetails.ProxyNumber+"','riaToken':'"+infoToGetDetails.RiaToken +"','enToken':'"+infoToGetDetails.EnToken+"'}"
                requestData = btoa(requestData)
                let payload = {
                    "partitionId": "RIA",
                    "channelId": APP_CONFIG.WalletCardChannelId,
                    "channelPassword": APP_CONFIG.WalletCardChannelPassword,
                    "requestRefNo":parsedDate.substring(2,14),
                    "requestTimeStamp": parsedDate,
                    "requestType": "FETCHCRDCVV",
                    "requestData": requestData,
                    "clientCombinationKey":"",
                    "serverCombinationKey":""
                    }
                let cardDetailResult = await this.httpProvider.postExtern(infoToGetDetails.Url, payload, {}, 'json', null, true);
                if(cardDetailResult && cardDetailResult.responseCode && cardDetailResult.responseCode === "000"  && cardDetailResult.responseData && cardDetailResult.responseData.length > 0){
                    cardDetailResult.responseData = atob(cardDetailResult.responseData);
                    cardDetailResult.responseData = JSON.parse(cardDetailResult.responseData);
                    cardDetailResult.responseData.cardNumber = this.rsaEncryptnProvider.decryptText(infoToGetDetails.DecryptionKey, cardDetailResult.responseData.cardNumber);
                    cardDetailResult.responseData.CVV2 = this.rsaEncryptnProvider.decryptText(infoToGetDetails.DecryptionKey, cardDetailResult.responseData.CVV2);
                    return cardDetailResult.responseData;
                } 
                return null
        }
        return null;
    }

    async getCardAllSettingDetails(includelimit: boolean, includechannel:boolean ,proxyNumber: string): Promise<any[]>{
        return this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/cards/details?includelimit=${includelimit}&includechannel=${includechannel}&proxynumber=${proxyNumber}`);
    }


    // common functions 
    setCardButtonText(card, walletDetail, isCallFromWallet) {
        if (card) {
            let btnText: string;
            if(this.isCardExpired(card)){
                btnText = this.translate.instant('page.eWalletPage.cardActivityPage.replaceCardButton');
            } else if (walletDetail.CardRequested && card.CardType == CARDTYPE.PHYSICAL_CARD) {
                btnText = this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.requestedButton');
            } else {
                switch (card.Status) {
                    case CARDSTATUS.ACTIVE:
                        if(!card.PinCreated && card.CardType == CARDTYPE.PHYSICAL_CARD){
                            btnText = this.translate.instant('page.eWalletPage.cardActivityPage.createPINButton');
                        }else{
                            btnText = isCallFromWallet ? this.translate.instant('page.activityPage.detailsButton') : this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.manageButton');
                        }
                        break;
                    case CARDSTATUS.INACTIVE:
                        btnText = this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.activateButton');
                        break;
                    case CARDSTATUS.TEMPBLK:
                    case CARDSTATUS.CMPLNCEBLK:
                        btnText = this.translate.instant('page.eWalletPage.cardActivityPage.lockedButton');
                        break;
                    case CARDSTATUS.PERMBLK:
                        btnText = this.translate.instant('page.eWalletPage.cardActivityPage.replaceCardButton');
                        break;
                    default:
                        btnText = this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.getCardButton');
                }
            }
            return btnText ? btnText : btnText = this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.getCardButton');
        }
    }

    getWalletCardDetails(walletCards) {
        for (let item in CARDTYPE) {
            if (!isNaN(Number(item))) {
                let addCard = new WalletCard();
                addCard.CardType = Number(item);
                addCard.Status = null;
                walletCards.push(addCard);
            }
        }
        this.walletCards = walletCards.sort((a, b) => {
            return b.CardType - a.CardType;
        });
        return this.walletCards;
    }

    setWalletCardDetailsVal(walletCards, walletDetails) {
        this.walletCards = walletCards.map(obj1 => { 
            let obj2 = walletDetails.Cards.find(obj2 => obj2.CardType === obj1.CardType);
            if(obj1)
                obj1.maskedCardNumber = this.getLastFourDigitsofCard(obj1, true, false);
            if(obj2)
                obj2.maskedCardNumber = this.getLastFourDigitsofCard(obj2, true, false);
            
            return { ...obj1, ...obj2 }; 
        });
        return this.walletCards;
    }

    goBackToWalletHome(canRefreshHome = false) {
        if(canRefreshHome === true){
            this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage)
        } else{
            this.routeProvider.popTo(this.routeProvider.pages.WalletHome);
        }
    }

    // open modal functions
    getVirtualCard(walletDetails, screen, cardReplace= null) {
        this.routeProvider.openActionSheetNew(this.routeProvider.pages.VirtualCardApplyModal,
        {
            subtitle: this.assignTermsAndConditionsURLwithLocale('page.eWalletPage.prepaidCardIssuancePage.mastercardTC'),
            primaryAction: () => {
                this.getVirtualCardPopUptoWalletPin(walletDetails, screen, cardReplace);
            },
        });
    }

    getVirtualCardPopUptoWalletPin(walletDetails, screen , cardReplace) {
        const payload = {
            showBack: true,
            actionType: PinActionType.CardApply,
            WalletDetails: walletDetails,
            WrongPinAttemptsCount: 0,
            IsWalletActive: true,
            IsSendOrRequest: PinActionType.CardApply,
            onContinue: (params) => {
                this.continueVirtualCardApply(params, screen, cardReplace);
            }
        };
        this.routeProvider.push(this.routeProvider.pages.WalletPinPage, payload);
    }

    async continueVirtualCardApply(params, screen, cardReplace) {
        let payload;
        if(cardReplace && cardReplace.ReplacementReason){
            payload = {
                TransactionPin: params.TransactionPin,
                CardType: WALLETCARDTYPE.VIRTUAL,
                ReplacementReason: cardReplace.ReplacementReason, 
                ProxyNumber: cardReplace.ProxyNumber
            };
        }else{
            payload = {
                TransactionPin: params.TransactionPin,
                CardType: WALLETCARDTYPE.VIRTUAL
            };
        }
        this.routeProvider.openModal(this.routeProvider.pages.VirtualCardContinuePage, {
            payload: payload,
            actionType: WALLETCARDACTIONTYPE.VIRTUAL_CARD_APPLY
        });
    }

    getWarningModalofCardApply(payload) {
        if(payload.CardType === CARDTYPE.PHYSICAL_CARD){
            this.routeProvider.push(this.routeProvider.pages.PhysicalCardApplyWarningModal, {
                payload: payload,
                primaryButtonAction: async () => {
                    this.analytics.trackEvent({
                        eventName: AnalyticsEventType.WalletCardLocationsOpened, analyticsData: {}
                    });
                    this.routeProvider.openModal(this.routeProvider.pages.getCardToNearStore);
                },
                secondaryButtonAction: async () => {
                    this.routeProvider.push(this.routeProvider.pages.PhysicalCardSelectPage, { isShowBack: false });
                },
                onClose: async () => this.goBackToWalletHome()
            });
        }else if(payload.CardType === CARDTYPE.VIRTUAL_CARD){
            this.routeProvider.push(this.routeProvider.pages.VirtualCardApplyWarningModal, {
                payload: payload,
                secondaryButtonAction: async () => {
                    this.routeProvider.push(this.routeProvider.pages.CardSelectionPage, { isShowBack: false });
                },
                onClose: async () => this.goBackToWalletHome(true)
            });
        }
    }

    getWalletPhysicalCardActive(card) {
        this.routeProvider.openModal(this.routeProvider.pages.PhysicalCardActivePage, {
            primaryButtonAction: async () => {
                this.getCardCvvSetUpPage(card);
            },
            secondaryButtonAction: async () => {
                this.cardDidnotArriveModal();
            },
            onClose: async () => this.goBackToWalletHome()
        });
    }

    cardDidnotArriveModal() {
        this.analytics.trackEvent({ eventName: AnalyticsEventType.CardReplacementStarted, analyticsData: {"reason": AnalyticsCardLostReasonsType.NotArrived} });
        this.routeProvider.openActionSheetNew(this.routeProvider.pages.CardDidnotArriveModalPage,
        {
            trackEvent: AnalyticsEventType.ContactModalDisplayed,
            trackParams: {
                location: SegmentLocationNames.WalletCard,
                reason: ContactModalReasons.RiaCardNotDelivered
            },
            primaryAction: async () => {
                this.call.callCustomerService(SegmentLocationNames.WalletCard, ContactModalReasons.RiaCardNotDelivered);
            }
        });
    }

    getSuccessModalofCardApply(payload, cardDetail = null) {
        if(payload.CardType == CARDTYPE.VIRTUAL_CARD){
            this.routeProvider.push(this.routeProvider.pages.VirtualCardApplySuccessModal, {
                payload: payload,
                primaryButtonAction: async () => {
                    this.updateWalletCards(cardDetail[0]);
                    let cards = this.getActiveCards(this.walletCards);
                    this.routeProvider.openModal(this.routeProvider.pages.CardSettingsHomePage, {walletCards: cards, selectedCard: cardDetail[0], isCardStatusChanged: true});
                },
                secondaryButtonAction: async () => {
                    this.goBackToWalletHome(true);
                },
                onClose: async () => this.goBackToWalletHome(true)
            });
        }else if(payload.CardType == CARDTYPE.PHYSICAL_CARD){
            this.routeProvider.push(this.routeProvider.pages.PhysicalCardApplySuccessModal, {
                payload: payload,
                primaryButtonAction: async () => {
                    this.goBackToWalletHome(true);
                },
                onClose: async () => this.goBackToWalletHome(true)
            });
        }
    }

    getWarningModalofCVVSetup(payload, card, rs) {
        let subTitle;
        let isshowSecondaryButton: boolean = true; 
        if (rs && rs.Value) {
            if(rs.Value.InvalidCvvAttempt === 1){
                subTitle = this.translate.instant('page.eWalletPage.physicalCardActivationPage.incorrectCVVText');
            }else if (rs.Value.InvalidCvvAttempt === 2){
                subTitle = this.translate.instant('page.eWalletPage.physicalCardActivationPage.attemptsRemainingText');
            }else if(rs.Value.InvalidCvvAttempt){
                isshowSecondaryButton = false;
                subTitle = this.translate.instant('page.eWalletPage.physicalCardActivationPage.maxAttemptsText');
            }
        }
        this.routeProvider.push(this.routeProvider.pages.CardCvvSetUpWarningModal, {
            payload: payload,
            primaryBtnText: isshowSecondaryButton ? this.translate.instant('global.tryAgainButton') : this.translate.instant('global.okButton'),
            subTitle: subTitle,
            showSecondaryButton: isshowSecondaryButton,
            primaryButtonAction: async () => {
                if (isshowSecondaryButton) {
                    this.getCardCvvSetUpPage(card);
                } else {
                    this.goBackToWalletHome();
                }
            },
            secondaryButtonAction: async () => {
                this.goBackToWalletHome();
            },
            onClose: async () => this.goBackToWalletHome()
        });
    }

    getCardCvvSetUpPage(cardDetail) {
        this.routeProvider.push(this.routeProvider.pages.CardCvvSetUpPage, { cardDetail: cardDetail } );
    }

    getCardPinSetUpPage(isPINCheck, pinValue, screenCallFrom, cardDetail = null, transactionPin = null) {
        this.routeProvider.openModal(this.routeProvider.pages.CardPinSetUpConfirmPinsetUpPage,
            {
                title: isPINCheck ? this.translate.instant('page.eWalletPage.prepaidCardPINPage.createPINTitle') : this.translate.instant('page.eWalletPage.prepaidCardPINPage.confirmPINTitle'),
                subTitle: isPINCheck ? this.translate.instant('page.eWalletPage.prepaidCardPINPage.createPINText') : this.translate.instant('page.eWalletPage.prepaidCardPINPage.confirmPINText'),
                isPINCheck: isPINCheck,
                isPinConfirmCheck: isPINCheck ? false : true,
                pinValueConfirm: pinValue,
                screenCallFrom: screenCallFrom,
                cardDetail: cardDetail,
                transactionPin: transactionPin
            }
        );
    }

    getSuccessPhysicalCardPinSet(isChangePin=false) {
        
        const messagePage= isChangePin?this.routeProvider.pages.PhysicalCardPinChangeSuccessModal:this.routeProvider.pages.PhysicalCardPinSetSuccessModal;
        this.routeProvider.push(messagePage, {
            primaryButtonAction: async () => {
                this.goBackToWalletHome(true);
            },
            onClose: async () => this.goBackToWalletHome(true)
        });
    }

    getWarningPhysicalCardPinSet(card, isCardPinFailed:boolean = false, actionTy) {
        let subTitle; 
        let sourceLocation;
        let actionType;
        if(actionTy && actionTy === WALLETCARDACTIONTYPE.PYSICAL_CARD_PIN_CHANGE){
            subTitle = this.translate.instant('page.eWalletPage.prepaidCardPINPage.CreatePINErrorText');
            sourceLocation = WALLETCARDPINTYPE.CARDPIN_CHANGE;
            actionType = PinActionType.ResetCardPIN;
        }else {
            subTitle = this.translate.instant('page.eWalletPage.prepaidCardPINPage.cardActivationErrorText');
            sourceLocation = WALLETCARDPINTYPE.CARDPIN_SETUP;
            actionType = PinActionType.CreateCardPIN;
        }
        this.routeProvider.openModal(this.routeProvider.pages.PhysicalCardPinSetWarningModal,  {
            subTitle: subTitle,
            primaryButtonAction: async () => {
                if(isCardPinFailed){
                    this.routeProvider.openModal(this.routeProvider.pages.WalletPinPage, { sourceLocation: sourceLocation, actionType: actionType }, (pin) => this.setCardPin(card, pin));
                }else{
                    this.getCardCvvSetUpPage(card)
                }
            },
            secondaryButtonAction: async () => {
                this.goBackToWalletHome();
            },
            onClose: async () => {
                this.goBackToWalletHome();
            }
        });
    }

    logCardManagementAccessedEvent(card, location = "Card Management") {
        let cardType = (card.CardType == CARDTYPE.PHYSICAL_CARD) ? this.translate.instant('page.eWalletPage.cardActivityPage.physicalText') : this.translate.instant('page.eWalletPage.prepaidCardActivityPage.virtualText');
        let cardNumber = card.CardNumber.length > 0 ? card.CardNumber.slice(-4) : "";
        this.analytics.trackEvent({ eventName: AnalyticsEventType.CardManagementAccessed, analyticsData: { "location": location, cardType: cardType, cardLastFourDigits: cardNumber } });
    }

    setCardPin(card, pin){
        if(pin) this.getCardPinSetUpPage(true, null, 'wallet', card, pin)
    }

    getCardTypeText(card) {
        return (card.CardType == CARDTYPE.PHYSICAL_CARD) ? this.translate.instant('page.eWalletPage.cardActivityPage.physicalText') : this.translate.instant('page.eWalletPage.prepaidCardActivityPage.virtualText')
    }

    getLastFourDigitsofCard(card, withHideText = false, typeText = false) {
        let returnText = "";
        if(card && card.CardNumber && card.CardNumber.length > 0){
            returnText = withHideText ? "•••• " : ""
            returnText += card.CardNumber.substring(4, card.CardNumber.length);
            if(typeText) returnText += " " + this.getCardTypeText(card);
        }
        return returnText;
    }

    getActiveCards(walletCards){
        if(walletCards){
            return walletCards.filter(card => card.Status === CARDSTATUS.ACTIVE || card.Status === CARDSTATUS.TEMPBLK || card.Status === CARDSTATUS.CMPLNCEBLK);
        }
        return null;
    }

    showCardReplacementConfirmationModal(reasonIsDamaged = false, cardReplaceDetail?, isSkipeReqModal:boolean = false){
        let modalToOpen = this.routeProvider.pages.ReplaceCardConfirmationModal;
        if(reasonIsDamaged === true){
            modalToOpen = this.routeProvider.pages.ReplaceCardConfirmationForDamagedModal;
        }
        if(isSkipeReqModal){
            this.routeProvider.openModal(this.routeProvider.pages.PhysicalCardSelectPage, { isShowBack: false , cardReplace: cardReplaceDetail });
        }else{
            this.routeProvider.openActionSheetNew(modalToOpen,  {
                openChatWidgetIfAvailable: reasonIsDamaged,
                trackEvent: AnalyticsEventType.ContactModalDisplayed,
                trackParams: { 
                    location: SegmentLocationNames.WalletCard,
                    reason: reasonIsDamaged ? ContactModalReasons.RiaCardDamaged : ContactModalReasons.RiaCardUserProblemReport
                },
                primaryButtonAction: async () => {
                    if(reasonIsDamaged === true){
                        this.call.callCustomerService(SegmentLocationNames.WalletCard, ContactModalReasons.RiaCardUserProblemReport);
                    } else{
                        this.routeProvider.push(this.routeProvider.pages.PhysicalCardSelectPage, { isShowBack: false , cardReplace: cardReplaceDetail });
                    }
            }});
        }
    }

    isCardExpired(card){
        if((card.isExpiring === true && card.DaysUntilExpiry <= 0) || (card.DaysUntilExpiry <= 0)){
            return true
        } else {
            return false;
        }
    }

    assignTermsAndConditionsURLwithLocale(termsAndConditions) {
        let locale = RmtTranslateComponent.getRedirectLanguage();
        return this.translate.instant(termsAndConditions).replace('{{locale}}', locale);
    }

    updateWalletCards(cardToUpdate) {
        this.walletCards.forEach((card, index) => {
            if(card.CardType === cardToUpdate.CardType) {
                this.walletCards[index] = cardToUpdate;
            }
        });
    }

    accountLockedModalAlert(isCardLocked){
        let title = isCardLocked ? this.translate.instant('page.eWalletPage.prepaidCardActivityPage.cardLockedForSecurityText') : this.translate.instant('page.eWalletPage.walletInactivityText');
        this.routeProvider.openActionSheetNew(
          this.routeProvider.pages.ModalAlertPage,
          {
            title: title,
            subtitle:  this.translate.instant('page.eWalletPage.prepaidCardActivityPage.cardLockedForSecurityText'),
            swapButtons: true,
            image: 'assets/icon/yellow-warning-icon.svg',
            primaryButtonText: this.translate.instant('global.callCustomerServiceButton'),
            showSecondaryButton : true,
            secondaryButtonText: this.translate.instant('global.notNowButton'),
            trackEvent: AnalyticsEventType.ContactModalDisplayed,
            openChatWidgetIfAvailable: true,
            trackParams: {
                location: SegmentLocationNames.Wallet,
                reason: ContactModalReasons.RiaCardPermanentlyBlocked
            },
            dismissFromSecondary: true,
            primaryAction: () => {
                this.call.callCustomerService(SegmentLocationNames.Wallet, ContactModalReasons.RiaCardPermanentlyBlocked);
            }
          });
      }
      
      setAnalyticsCardRequestEvent(isPhysicalCard: boolean){
        this.analytics.trackEvent({
          eventName: AnalyticsEventType.WalletCardRequestStarted, analyticsData: {
              location: AnalyticsWalletCard.cardReqHome,
              cardType: isPhysicalCard ? this.translate.instant('page.eWalletPage.cardActivityPage.physicalText') : this.translate.instant('page.eWalletPage.prepaidCardActivityPage.virtualText'),
              referrer: AnalyticsWalletCard.cardReqHome
          }
        });
      }

      getActiveCardsForSegmentEv(cards: any[]): string[] {
        const cardNames = ["Virtual Card", "Physical Card"];
        return cards
          .filter(card => card.Status === 1)
          .map(card => cardNames[card.CardType]);
      };

      getCardStatusForSegmentEv(): WalletCardsStatuses | null {
        if ((this.walletCards && this.walletCards.length < 1) || !this.walletCards) return null;
        let physicalCardStatus = null;
        let virtualCardStatus = null;

        this.walletCards.forEach(card => {
            switch (card.Status) {
                case CARDSTATUS.ACTIVE:
                    card.CardType == CARDTYPE.PHYSICAL_CARD ? physicalCardStatus = WALLETSTATUSSTRING.ACTIVE : virtualCardStatus = WALLETSTATUSSTRING.ACTIVE;
                    break
                case CARDSTATUS.INACTIVE:
                    card.CardType == CARDTYPE.PHYSICAL_CARD ? physicalCardStatus = WALLETSTATUSSTRING.INACTIVE : virtualCardStatus = WALLETSTATUSSTRING.INACTIVE;
                    break
                case CARDSTATUS.TEMPBLK:
                    card.CardType == CARDTYPE.PHYSICAL_CARD ? physicalCardStatus = WALLETSTATUSSTRING.TEMPBLK : virtualCardStatus = WALLETSTATUSSTRING.TEMPBLK;
                case CARDSTATUS.CMPLNCEBLK:
                    card.CardType == CARDTYPE.PHYSICAL_CARD ? physicalCardStatus = WALLETSTATUSSTRING.TEMPLK : virtualCardStatus = WALLETSTATUSSTRING.TEMPLK;
                    break
                case CARDSTATUS.PERMBLK:
                    card.CardType == CARDTYPE.PHYSICAL_CARD ? physicalCardStatus = WALLETSTATUSSTRING.PERMBLK : virtualCardStatus = WALLETSTATUSSTRING.PERMBLK;
                    break
                default:
                    return null
            }
        });

        return {
            physicalCardStatus,
            virtualCardStatus
        }
      }
}



// WEBPACK FOOTER //
// ./src/providers/wallet/wallet-card.ts